import { memo, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setStationIconsLegendPopup } from "../model/actions";

import UIDialog from "./controls/Dialog";
import { Info as InfoIcon } from "./icons";
import StationIconElevatorLegend from "./StationIconElevatorLegend";
import StationIconsLegend from "./StationIconsLegend";

import "./StationIconsLegendPopup.scss";

function StationIconsLegendPopup() {
  const legendPopupData = useSelector((state) => state.stationIconsLegendPopup);
  const dispatch = useDispatch();

  const title = useMemo(() => {
    return (
      <div className="trl-legend-popup-header">
        {legendPopupData?.onlyElevatorInfo ? (
          <div className="trl-elevator-title">
            <div className="trl-header-title">Aufzug-Info</div>
            <div className="trl-header-subtitle">
              {legendPopupData.station?.name}
            </div>
          </div>
        ) : (
          <div>
            <div className="trl-header-icon">
              <InfoIcon />
            </div>
            <div className="trl-header-title">Legende</div>
          </div>
        )}
      </div>
    );
  }, [legendPopupData]);

  const close = useCallback(() => {
    dispatch(setStationIconsLegendPopup(null));
  }, [dispatch]);

  return (
    <UIDialog
      className="tm-dialog-container trl-legend-popup"
      isModal
      isOpen={!!legendPopupData}
      onClickOutside={close}
      onClose={close}
      title={title}
    >
      {legendPopupData?.onlyElevatorInfo ? (
        <StationIconElevatorLegend {...(legendPopupData?.station || {})} />
      ) : (
        <StationIconsLegend {...(legendPopupData?.station || {})} />
      )}
    </UIDialog>
  );
}

export default memo(StationIconsLegendPopup);
